import { render, staticRenderFns } from "./SchedulesCard.vue?vue&type=template&id=1b47e6a3&scoped=true"
import script from "./SchedulesCard.vue?vue&type=script&lang=js"
export * from "./SchedulesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b47e6a3",
  null
  
)

export default component.exports